import state from './translationState'
import mutations from './translationMutations'
import getters from './translationGetters'
import actions from './translationActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
